import PropTypes from 'prop-types';

export const props = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  body: PropTypes.string,
  element: PropTypes.element,
  titleType: PropTypes.string,
};
